<template>
  <section class="page-body">

    <div class="page-title-bar sticky">
      <h1>{{ title }}</h1>

      <router-link :to="{ name: 'AddProduct' }" tag="button" class="btn" title="Add Product">
        <i class="fa-thin fa-plus-circle"></i>
        Add Product
      </router-link>
    </div>
    
    <div class="content-panel">
      <div class="panel-body no-title">
        <div class="data-table">
          <div class="data-table-search">
              <div class="actions">
                <span class="search-icon"><i class="fa-thin fa-search"></i></span>
                <input class="search-input" type="text" :placeholder="'Search Products'" v-model="tableSearchTerm" />
              </div>
          </div>

          <vue-good-table
              :columns="columns"
              :rows="gridList"
              @on-row-click="viewPage"
              styleClass="vgt-table bookings-table"
              :sort-options="{
                  enabled: true,
                  initialSortBy: {field: 'name', type: 'asc'}
              }"

              :search-options="{
                  enabled: true,
                  skipDiacritics: true,
                  externalQuery: tableSearchTerm
              }"

              :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 50,
                  position: 'bottom',
                  dropdownAllowAll: false,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
              }"
          >

              <template slot="table-row" slot-scope="props">
                  <a :title="props.row.name" v-if="props.column.field == 'name'"><strong>{{ props.row.name }}</strong></a>
                  <span v-if="props.column.field  == 'price'">{{ props.row.price }}</span>
                  <span v-if="props.column.field  == 'inventory'">{{ props.row.inventory }}</span>
                  <span v-if="props.column.field  == 'active'" :style="{color: props.row.active ? 'green' : 'red'}" class="fa" :class="props.row.active ? 'fa-check' : 'fa-xmark'"></span>
              </template>

          </vue-good-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Products',
  data() {
    return {
      title: 'All Products',
      tableSearchTerm: '',
      columns: [
        {
          label: 'Name',
          field: 'name',
          tdClass: 'title-col',
        },
        {
          label: 'Price',
          field: 'price'
        },
        {
          label: 'Inventory',
          field: 'inventory'
        },
        {
          label: 'Active',
          field: 'active'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
        db : 'db',
        gridList: 'getProductsData'
    })
  },

  metaInfo: {
    title: 'All Products'
  },

  async mounted() {
    let self = this;
    self.getGridData();
  },

  methods: {
    getGridData: async function(forceUpdate) {
      let self = this;

      if(!self.gridList.length || forceUpdate) {
        await self.$store.dispatch('bindProductsData');
      }
    },

    viewPage: function(params) {
      let self = this;
      let id = params.row.id;

      self.$router.push({name: 'EditProduct', params:{ref:id}})
    }
  },

  watch: {
    'db': function() {
      let self = this;
      
      self.getGridData(true);
    }
  }
}
</script>
